// extracted by mini-css-extract-plugin
export default {"modal__header":"styles_modal__header__j4KAM","modal__body":"styles_modal__body__Nqc52","modal__content":"styles_modal__content__Ftkey","modal__dialog":"styles_modal__dialog__ENxQB"};